import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Taxwc { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '發票號碼 (WC001) 不可空白'}) 
    @MaxLength(20,{message: '發票號碼 (WC001) 資料太長'})
    WC001: string = '';            // 發票號碼 20 InvoiceNumber  CancelInvoiceNumber

    @IsNotEmpty({message: '訊息類別 (WC002) 不可空白'}) 
    @MaxLength(5,{message: '訊息類別 (WC002) 資料太長'})
    WC002: string = '';            // 訊息類別 5 A0101, A0102, A0201, A0202, A0301, A0302, A0401, A0501, A0601, B0101, B0102, B0201, B0202, B0401, B0501, C0401, C0501, C0701, D0401, D0501, E0401, E0402, E0501

    @IsNotEmpty({message: '申報年月 (WC003) 不可空白'}) 
    @MaxLength(6,{message: '申報年月 (WC003) 資料太長'})
    WC003: string = '';            // 申報年月 6 COPY(WC007,1,6)

    @MaxLength(8,{message: '開立日期 (WC004) 資料太長'})
    WC004: string = '';            // 開立日期 8 InvoiceDate

    @MaxLength(10,{message: '買方統一編號 (WC005) 資料太長'})
    WC005: string = '';            // 買方統一編號 10 Buyer.Identifier [1]  BuyerId  [1] E0401 E0402 BranchBan

    @MaxLength(10,{message: '賣方統一編號 (WC006) 資料太長'})
    WC006: string = '';            // 賣方統一編號 10 Seller.Identifier   [1]  SellerId [1]

    @MaxLength(1,{message: '課稅別 (WC007) 資料太長'})
    WC007: string = '';            // 課稅別 1 TaxType[1]   1.應稅 2.零稅率 3.免稅 4.應稅(特種稅率) 9:混合應稅與免稅或零稅率(限收銀機發票無法分辨時使用)

    @MaxLength(1,{message: '來源方式 (WC008) 資料太長'})
    WC008: string = '1';            // 來源方式 1 [DEF:"1"]1.拋轉 2.人工

    @MaxLength(4,{message: '來源單別 (WC009) 資料太長'})
    WC009: string = '';            // 來源單別 4 TG001

    @MaxLength(20,{message: '來源單號 (WC010) 資料太長'})
    WC010: string = '';            // 來源單號 20 TG002

    @MaxLength(6,{message: '載具類別號碼 (WC011) 資料太長'})
    WC011: string = '';            // 載具類別號碼 6 TG254 CarrierType[0..1] [DEF:'']  手機條碼:3J0002 自然人憑證條碼:CQ0001

    @MaxLength(64,{message: '載具顯碼id (WC012) 資料太長'})
    WC012: string = '';            // 載具顯碼id 64 TG255  CarrierId1[0..1]  載具顯碼id, [DEF:'']

    @MaxLength(64,{message: '載具隱碼id (WC013) 資料太長'})
    WC013: string = '';            // 載具隱碼id 64 TG256 CarrierId2[0..1]  載具隱碼id, [DEF:'']

    @MaxLength(1,{message: '紙本電子發票列印註記 (WC014) 資料太長'})
    WC014: string = 'N';            // 紙本電子發票列印註記 1 TG257 PrintMark[1] (Y/N)[DEF:"N"]

    @MaxLength(1,{message: '買受人註記欄 (WC015) 資料太長'})
    WC015: string = '';            // 買受人註記欄 1 BuyerRemark[0..1] 1: 2: 3: 4:

    @MaxLength(60,{message: '賣方名稱 (WC016) 資料太長'})
    WC016: string = '';            // 賣方名稱 60 Seller.Name [1]

    @MaxLength(100,{message: '賣方地址 (WC017) 資料太長'})
    WC017: string = '';            // 賣方地址 100 Seller.Address [0..1] N/A

    @MaxLength(30,{message: '賣方負責人姓名 (WC018) 資料太長'})
    WC018: string = '';            // 賣方負責人姓名 30 Seller.PersonInCharge  [0..1] N/A

    @MaxLength(20,{message: '賣方電話 (WC019) 資料太長'})
    WC019: string = '';            // 賣方電話 20 Seller.TelephoneNumber [0..1] N/A

    @MaxLength(20,{message: '賣方傳真 (WC020) 資料太長'})
    WC020: string = '';            // 賣方傳真 20 Seller.FacsimileNumber [0..1]

    @MaxLength(80,{message: '賣方電子郵件地址 (WC021) 資料太長'})
    WC021: string = '';            // 賣方電子郵件地址 80 Seller.EmailAddress [0..1] N/A

    @MaxLength(72,{message: '買方名稱 (WC022) 資料太長'})
    WC022: string = '';            // 買方名稱 72 Buyer.Name [1]

    @MaxLength(100,{message: '買方地址 (WC023) 資料太長'})
    WC023: string = '';            // 買方地址 100 Buyer.Address [0..1]

    @MaxLength(30,{message: '買方負責人姓名 (WC024) 資料太長'})
    WC024: string = '';            // 買方負責人姓名 30 Buyer.PersonInCharge [0..1] N/A

    @MaxLength(20,{message: '買方電話號碼 (WC025) 資料太長'})
    WC025: string = '';            // 買方電話號碼 20 Buyer.TelephoneNumber [0..1]

    @MaxLength(20,{message: '買方傳真號碼 (WC026) 資料太長'})
    WC026: string = '';            // 買方傳真號碼 20 Buyer.FacsimileNumber [0..1]

    @MaxLength(80,{message: '買方電子郵件 (WC027) 資料太長'})
    WC027: string = '';            // 買方電子郵件 80 Buyer.EmailAddress [0..1]

    @MaxLength(10,{message: '發票檢查碼 (WC028) 資料太長'})
    WC028: string = '';            // 發票檢查碼 10 CheckNumber [0..1]  若實際交付發票印製格式為電子發票格式，則不可傳此欄位。 若實際交付發票印製格式為電子計算機發票，則限填營業人自訂檢查碼或”P”。 若實際交付發票印製格式非屬上述格式，則限填”P”。若為捐贈發票或以非營業人會員載具索取發票，則不可傳此欄位。

    @MaxLength(10,{message: '捐贈對象 (WC029) 資料太長'})
    WC029: string = '';            // 捐贈對象 10 NPOBAN[0..1] TG253 愛心碼 3~7碼 , 當捐贈註記='1'時,此欄不可空白

    @MaxLength(2,{message: '發票類別 (WC030) 資料太長'})
    WC030: string = '';            // 發票類別 2 1碼.轉XML前加0  InvoiceType[1]  01.三聯式 02.二聯式 03.二聯式收銀機 04.特種稅額 05.電子計算機 06.三聯式收銀機 07：一般稅額計算之電子發票 08：特種稅額計算之電子發票

    @MaxLength(1,{message: '捐贈註記 (WC031) 資料太長'})
    WC031: string = '0';            // 捐贈註記 1 DonateMark[1] TG252  0/非捐贈發票 1/捐贈發票 [DEF:0]

    @IsNumber() 
    WC032: number = 0;            // 稅率 8.5 TaxRate[1] 範例：稅率為5%時本欄位值 為0.05

    @IsNumber() 
    WC033: number =  0;            // 扣抵金額 21.6 Amount.DiscountAmount [0..1] 供營業人備註以便內部查看交易折扣註記使用

    @IsNumber() 
    WC034: number =  0;            // 原幣金額 21.6 Amount.OriginalCurrencyAmount [0..1] 供營業人外幣報價特殊需求

    @IsNumber() 
    WC035: number =  0;            // 匯率 20.9 Amount.ExchangeRate [0..1]

    @MaxLength(4,{message: '幣別 (WC036) 資料太長'})
    WC036: string = '';            // 幣別 4 Amount.Currency [0..1]

    @MaxLength(4,{message: '發票防偽隨機碼 (WC037) 資料太長'})
    WC037: string = '';            // 發票防偽隨機碼 4 TG258  RandomNumber[1] 發票防偽隨機碼, 抓發票號碼之3,5,7,9碼+1921後,取前四碼

    @MaxLength(1,{message: '發票開立上傳碼 (WC038) 資料太長'})
    WC038: string = 'N';            // 發票開立上傳碼 1 TG259     (Y/N)[DEF:"N"]

    @MaxLength(8,{message: '發票作廢日期 (WC039) 資料太長'})
    WC039: string = '';            // 發票作廢日期 8 TG260  A0202:CancelDate [1]

    @MaxLength(8,{message: '發票作廢時間 (WC040) 資料太長'})
    WC040: string = '';            // 發票作廢時間 8 TG261  A0202:CancelTime [1]

    @MaxLength(1,{message: '發票作廢碼 (WC041) 資料太長'})
    WC041: string = 'N';            // 發票作廢碼 1 TG263  (Y/N)[DEF:"N"]

    @MaxLength(1,{message: '發票作廢上傳碼 (WC042) 資料太長'})
    WC042: string = 'N';            // 發票作廢上傳碼 1 TG264 (Y/N)[DEF:"N"]

    @MaxLength(60,{message: '專案作廢核准文號 (WC043) 資料太長'})
    WC043: string = '';            // 專案作廢核准文號 60 TG267

    @MaxLength(200,{message: '發票作廢原因 (WC044) 資料太長'})
    WC044: string = '';            // 發票作廢原因 200 TG262

    @MaxLength(8,{message: '接收(退回)日期 (WC045) 資料太長'})
    WC045: string = '';            // 接收(退回)日期 8 TG265 ReceiveDate [1]

    @MaxLength(8,{message: '接收(退回)時間 (WC046) 資料太長'})
    WC046: string = '';            // 接收(退回)時間 8 TG266 ReceiveTime [1]

    @MaxLength(1,{message: '狀態碼 (WC047) 資料太長'})
    WC047: string = '1';            // 狀態碼 1 [DEF:"1"] 1.電子發票A0101 A0201 A0301 A0401 A0501 A0601 B0101 B0201 B0401 B0501 C0401 C0501 C0701 D0401 D0501 E0401 E0501 2.媒體轉出 3.接收確認 A0102 A0202 A0302 B0102 B0202 E0402

    @MaxLength(26,{message: '賣方營業人角色註記 (WC048) 資料太長'})
    WC048: string = '';            // 賣方營業人角色註記 26 Seller.RoleRemark [0..1]

    @MaxLength(26,{message: '買方營業人角色註記 (WC049) 資料太長'})
    WC049: string = '';            // 買方營業人角色註記 26 Buyer.RoleRemark [0..1]

    @MaxLength(2,{message: '沖帳別 (WC050) 資料太長'})
    WC050: string = '';            // 沖帳別 2 Category[0..1]

    @MaxLength(20,{message: '相關號碼 (WC051) 資料太長'})
    WC051: string = '';            // 相關號碼 20 RelateNumber[0..1]

    @MaxLength(200,{message: '總備註 (WC052) 資料太長'})
    WC052: string = '';            // 總備註 200 MainRemark [0..1]

    @MaxLength(255,{message: '備註 (WC053) 資料太長'})
    WC053: string = '';            // 備註 255 Remark [0..1]

    @MaxLength(1,{message: '買受人簽署適用零稅率 (WC054) 資料太長'})
    WC054: string = '';            // 買受人簽署適用零稅率 1 BondedAreaConfirm  [0..1]

    @MaxLength(1,{message: '更新碼 (WC055) 資料太長'})
    WC055: string = 'N';            // 更新碼 1 [DEF:"N"] 接收完有回寫單據後-->Y

    @MaxLength(255,{message: '執行結果 (WC056) 資料太長'})
    WC056: string = '';            // 執行結果 255 

    @MaxLength(5,{message: '來源碼 (WC057) 資料太長'})
    WC057: string = '';            // 來源碼 5 COPTG,COPTI,POSTA...

    @MaxLength(8,{message: '開立時間 (WC058) 資料太長'})
    WC058: string = '';            // 開立時間 8 TG251 InvoiceTime [1] HH:MM:SS

    @MaxLength(1,{message: '折讓種類 (WC059) 資料太長'})
    WC059: string = '';            // 折讓種類 1 AllowanceType[1] B0101  1:買方開立折讓證明單; 2:賣方折讓證明單通知

    @IsNumber() 
    WC060: number = 0;            // 應稅銷售額合計 11 Amount.SalesAmount[1] 仍是加總未稅金額TH037   (新台幣)  整數 *請注意銷售額合計不應為負數

    @IsNumber() 
    WC061: number = 0;            // 免稅銷售額合計 11 Amount.FreeTaxSalesAmount[1]  (新台幣)  整數(小數點以下四捨五入)，若無需求則填0 *請注意銷售額合計不應為負數。

    @IsNumber() 
    WC062: number = 0;            // 零稅率銷售額合計 11 Amount.ZeroTaxSalesAmount [1] (新台幣) 整數(小數點以下四捨五入)，若無需求則填0 *請注意銷售額合計不應為負數。

    @IsNumber() 
    WC063: number = 0;            // 營業稅額 11 Amount.TaxAmount [1] 整數 不應為負數。

    @IsNumber() 
    WC064: number = 0;            // 總計 11 Amount.TotalAmount[1]  整數 不應為負數。

    @MaxLength(1,{message: '折讓種類列表 (WC065) 資料太長'})
    WC065: string = '';            // 折讓種類列表 1 AllowanceTypeEnum   1:買方開立折讓證明單; 2:賣方折讓證明單通知

    @MaxLength(1,{message: '彙開註記 (WC066) 資料太長'})
    WC066: string = '';            // 彙開註記 1 GroupMark [0..1]  以”*”表示 彙開

    @MaxLength(30,{message: '批次號 (WC067) 資料太長'})
    WC067: string = '';            // 批次號 30 YYYYMMDDHHMMSS+UserID

    @MaxLength(200,{message: '發票退回原因 (WC068) 資料太長'})
    WC068: string = '';            // 發票退回原因 200 以下留著備用.先填空白

    @IsNumber() 
    WC069: number =  0;            // 預留欄位 21.6 old:總計

    @MaxLength(20,{message: '發票起始碼 (WC070) 資料太長'})
    WC070: string = '';            // 發票起始碼 20 發票起始碼

    @MaxLength(20,{message: '發票訖號 (WC071) 資料太長'})
    WC071: string = '';            // 發票訖號 20 發票訖號

    @MaxLength(16,{message: '預留欄位 (WC072) 資料太長'})
    WC072: string = '';            // 預留欄位 16 old:貨物名稱

    @MaxLength(40,{message: '預留欄位 (WC073) 資料太長'})
    WC073: string = '';            // 預留欄位 40 old:稅捐稽徵處名稱

    @MaxLength(8,{message: '檢核日期 (WC074) 資料太長'})
    WC074: string = '';            // 檢核日期 8 抓TAXWQ.WQ002 訊息日期    old:核准日

    @MaxLength(40,{message: '預留欄位 (WC075) 資料太長'})
    WC075: string = '';            // 預留欄位 40 old:核准文

    @MaxLength(20,{message: '預留欄位 (WC076) 資料太長'})
    WC076: string = '';            // 預留欄位 20 old:核准號

    @MaxLength(2,{message: '發票字軌 (WC077) 資料太長'})
    WC077: string = '';            // 發票字軌 2 發票字軌     old:格式代號   31:三聯 32:二聯 33:三聯折讓 34:二聯折讓 35:銷項電子發票 進項-> 21:三聯 22:二聯 23:三聯折讓 24:二聯折讓 25:電子發票 26 27 28 29

    @MaxLength(10,{message: '預留欄位 (WC078) 資料太長'})
    WC078: string = '';            // 預留欄位 10 old:申報公司

    @MaxLength(9,{message: '預留欄位 (WC079) 資料太長'})
    WC079: string = '';            // 預留欄位 9 old:稅籍編號

    @MaxLength(7,{message: '預留欄位 (WC080) 資料太長'})
    WC080: string = '';            // 預留欄位 7 old:流水號

    @IsNumber() 
    WC081: number =  0;            // 預留欄位 12 old:銷售金額

    @IsNumber() 
    WC082: number = 0;            // 預留欄位 10 old:營業稅額

    @MaxLength(1,{message: 'A0101接收確認 (WC083) 資料太長'})
    WC083: string = 'N';            // A0101接收確認 1 [DEF:"N"]

    @MaxLength(6,{message: 'TURNKEY狀態 (WC084) 資料太長'})
    WC084: string = '';            // TURNKEY狀態 6 (CASE STATUS WHEN 'C' THEN 'C:確認' WHEN 'P' THEN 'P:處理中' WHEN 'Agree' THEN 'Agree:同意接收' WHEN 'E' THEN 'E:錯誤' WHEN 'G' THEN 'G:處理完成' WHEN 'I' THEN 'I:處理中斷' ELSE STATUS END) [STATUS]

    @MaxLength(1,{message: 'A0102確認上傳碼 (WC085) 資料太長'})
    WC085: string = 'N';            // A0102確認上傳碼 1 [DEF:"N"]     old:彙加註記 A.彙加資料 空白表非彙加資料

    @MaxLength(1,{message: '預留欄位 (WC086) 資料太長'})
    WC086: string = '';            // 預留欄位 1 old:洋菸酒註記

    @MaxLength(10,{message: '預留欄位 (WC087) 資料太長'})
    WC087: string = '';            // 預留欄位 10 old:買受人代號

    @MaxLength(10,{message: '預留欄位 (WC088) 資料太長'})
    WC088: string = '';            // 預留欄位 10 old:買受人簡稱

    @IsNumber() 
    WC089: number = 0;            // 預留欄位 11.3 old:數量

    @IsNotEmpty({message: '傳送或接收 (WC090) 不可空白'}) 
    @MaxLength(1,{message: '傳送或接收 (WC090) 資料太長'})
    WC090: string = '1';            // 傳送或接收 1 [DEF:"1"] 1:傳送 2:接收 (CASE WC090 WHEN '1' THEN '1:傳送' WHEN '2' THEN '2:接收' END) AS 傳送或接收

    @MaxLength(1,{message: '預留欄位 (WC091) 資料太長'})
    WC091: string = '';            // 預留欄位 1 old:通關方式 1.非經海關 2.經海關

    @MaxLength(12,{message: '預留欄位 (WC092) 資料太長'})
    WC092: string = '';            // 預留欄位 12 old:證明文件名稱

    @MaxLength(2,{message: '預留欄位 (WC093) 資料太長'})
    WC093: string = '';            // 預留欄位 2 old:出口報單類別

    @MaxLength(20,{message: '預留欄位 (WC094) 資料太長'})
    WC094: string = '';            // 預留欄位 20 old:證明文件號碼

    @MaxLength(8,{message: '預留欄位 (WC095) 資料太長'})
    WC095: string = '';            // 預留欄位 8 old:輸出或結匯日期

    @MaxLength(60,{message: 'INVOICE_IDENTIFIER (WC096) 資料太長'})
    WC096: string = '';            // INVOICE_IDENTIFIER 60 turnkey KEY值 有發票號碼者: 類別5碼WC002+發票號碼10WC001+年月日8WC004  ELSE WC002+稅籍末三碼+WC004+TAX.MC006   old:用途

    @MaxLength(20,{message: '預留欄位 (WC097) 資料太長'})
    WC097: string = '';            // 預留欄位 20 old:註記號


}
